<template id="WatchIcon">
  <span v-b-tooltip.hover title="Number of Watchers" class="fa fa-eye" />
</template>

<script>
export default {
  name: "WatchIcon",
};
</script>
